import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider, useAuth } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import KasirPage from './pages/KasirPage';
import AdminPage from './pages/AdminPage';
import UsersPage from './pages/UsersPage';
import AuditPage from './pages/AuditPage';
import JurnalPage from './pages/JurnalPage';
import AccountsPage from './pages/AccountsPage';
import LedgerPage from './pages/LedgerPage';
import ReportsPage from './pages/ReportsPage';
import NeracaPage from './pages/NeracaPage';
import VendorsPage from './pages/VendorsPage';
import PayrollPage from './pages/PayrollPage';
import PayrollSlipPage from './pages/PayrollSlipPage';
import RemindersPage from './pages/RemindersPage';
import AssetsPage from './pages/AssetsPage';
import DashboardPage from './pages/DashboardPage';
import PhotoImportPage from './pages/PhotoImportPage';
import CalculatorPage from './pages/CalculatorPage';
import MarketplaceProductsPage from './pages/MarketplaceProductsPage';
import SalesCatalogPage from './pages/SalesCatalogPage';
import POImportPage from './pages/POImportPage';
import StockOpnamePage from './pages/StockOpnamePage';
import PajakMarketplacePage from './pages/PajakMarketplacePage';

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-stone-500 text-sm">
        Memuat…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.home_route) return <Navigate to={user.home_route} replace />;
  const home = user.role === 'admin' ? '/dashboard'
    : user.role === 'sales' ? '/sales/catalog'
    : user.role === 'kasir' ? '/kasir'
    : user.opname_enabled ? '/stock-opname'
    : '/kasir';
  return <Navigate to={home} replace />;
}

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<RootRedirect />} />
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/kasir"
              element={
                <ProtectedRoute>
                  <KasirPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute roles={['admin']}>
                  <AdminPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/users"
              element={
                <ProtectedRoute roles={['admin']}>
                  <UsersPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/audit"
              element={
                <ProtectedRoute roles={['admin']}>
                  <AuditPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/jurnal"
              element={
                <ProtectedRoute roles={['admin']}>
                  <JurnalPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/accounts"
              element={
                <ProtectedRoute roles={['admin']}>
                  <AccountsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ledger"
              element={
                <ProtectedRoute roles={['admin']}>
                  <LedgerPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reports"
              element={
                <ProtectedRoute roles={['admin']}>
                  <ReportsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/neraca"
              element={
                <ProtectedRoute roles={['admin']}>
                  <NeracaPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/vendors"
              element={
                <ProtectedRoute roles={['admin']}>
                  <VendorsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/payroll"
              element={
                <ProtectedRoute roles={['admin']}>
                  <PayrollPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/payroll/slip/:runId"
              element={
                <ProtectedRoute roles={['admin']}>
                  <PayrollSlipPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reminders"
              element={
                <ProtectedRoute roles={['admin']}>
                  <RemindersPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/kalkulator"
              element={
                <ProtectedRoute roles={['admin']}>
                  <CalculatorPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/produk-marketplace"
              element={
                <ProtectedRoute roles={['admin']}>
                  <MarketplaceProductsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/assets"
              element={
                <ProtectedRoute roles={['admin']}>
                  <AssetsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute roles={['admin']}>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/photo-import"
              element={
                <ProtectedRoute roles={['admin']}>
                  <PhotoImportPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/sales/catalog"
              element={
                <ProtectedRoute roles={['admin', 'sales']}>
                  <SalesCatalogPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/po-import"
              element={
                <ProtectedRoute roles={['admin']}>
                  <POImportPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/stock-opname"
              element={
                <ProtectedRoute roles={['admin']} allowOpname>
                  <StockOpnamePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/pajak"
              element={
                <ProtectedRoute roles={['admin']} allowPajak>
                  <PajakMarketplacePage />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
